import React from 'react';
import classNames from 'classnames';

const hyphenClasses = classNames('dashboard-assess-icon-item', 'dashboard-hyphen');

const HyphenIcon = () => <div className={hyphenClasses} />;

export default HyphenIcon;
